var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.dataFields),function(field){return _c('v-card',{key:field.id,attrs:{"tile":""}},[_c(_vm.getDefinitionType(field),{key:field.id,tag:"component",attrs:{"dataField":field}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }